import React from 'react';

const TablePlaceholder = () => {
  return (
    <div role="status" className="w-full animate-pulse overflow-x-auto">
      <table className="w-full">
        <tbody>
          {[...Array(10)].map((_, rowIndex) => (
            <tr 
              key={rowIndex}
              className={rowIndex % 2 === 0 ? "bg-tablebg" : "bg-tablebg2"}
            >
              {[...Array(10)].map((_, colIndex) => (
                <td key={rowIndex + "-" + colIndex} className="p-4">
                  <div className={`h-4 rounded ${
                    colIndex % 2 === 0 
                      ? "bg-gray-200 dark:bg-gray-700" 
                      : "bg-gray-300 dark:bg-gray-600"
                  }`}></div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default TablePlaceholder;